import { environment } from '@environments/environment.development';

const {
  aladdinOnDemandUrl,
  plpApiBaseUrl,
  pdpApiBaseUrl,
  pdpSpecSheetBaseUrl,
  pdpApiProductsByStyleColourUrl,
  pdpAvailabilityModalUrl,
  parentBySampleUrl,
  findRetailerBaseUrl
} = environment;

const externalApiRoutes = {
  GMAP_JS_API: (apiKey?: string) => `https://maps.googleapis.com/maps/api/js?v=weekly&libraries=places&key=${apiKey}`,
  GMAP_GET_DIRECTION_API: 'https://www.google.com/maps/dir/?api=1&destination=',
  GMAP_GEOCODE_API: (apiKey?: string) => `https://maps.googleapis.com/maps/api/geocode/json?key=${apiKey}&latlng=`,
  ROOMVO_SCRIPT: 'https://cdn.roomvo.com/static/scripts/b2b/aladdincommercial.js'
};

const defaultApiRoute = `${aladdinOnDemandUrl}/rest/v2/aladdin`;

export const apiRoutes = {
  ...externalApiRoutes,
  AUTHORIZATION_BEARER_TOKEN_API: `${aladdinOnDemandUrl}/authorizationserver/oauth/token`,
  REGISTER_USER_URL: `${defaultApiRoute}/users`,
  FORGOT_PASSWORD_URL: `${defaultApiRoute}/forgottenpasswordtokens`,
  RESET_PASSWORD_URL: `${defaultApiRoute}/resetpassword`,
  VALIDATE_OTP_URL: `${defaultApiRoute}/validateotp`,
  USER_PROFILE_URL: `${defaultApiRoute}/users`,
  CART_ANONYMOUS: `${defaultApiRoute}/users/anonymous/carts`,
  CART_COMMERCIAL: `${defaultApiRoute}/users`,
  CHECK_AVAILABILITY: `${defaultApiRoute}/products/find`,
  ADDRESS_CRUD_URL: `${defaultApiRoute}/users`,
  ORDERS: `${defaultApiRoute}/users`,
  PLP: plpApiBaseUrl,
  PDP: pdpApiBaseUrl,
  PDP_SPEC_SHEET_BASE_URL: pdpSpecSheetBaseUrl,
  PDP_STYLE_COLOR: pdpApiProductsByStyleColourUrl,
  AVAILABILITY_MODAL: pdpAvailabilityModalUrl,
  PARENT_BY_SAMPLE: parentBySampleUrl,
  FIND_A_RETAILER: findRetailerBaseUrl
};
